import { AppNamespace } from '../../state/app';

/**
 * Selector to get the isAppRebrandActiveFromInitialState flag from the app state.
 * This flag is set when the application is initialized from a saved session state
 * that contains the is_app_rebrand_active parameter.
 *
 * @param app - The app state from Redux
 * @returns true if the app rebrand was active in the initial state, false otherwise
 */
export const getIsAppRebrandActiveFromInitialState = (
    app: AppNamespace,
): boolean => {
    return app?.isAppRebrandActiveFromInitialState ?? false;
};
